import { render, staticRenderFns } from "./PeriodoEvaluacionSelect.vue?vue&type=template&id=3a27528e&scoped=true"
import script from "./PeriodoEvaluacionSelect.vue?vue&type=script&lang=js"
export * from "./PeriodoEvaluacionSelect.vue?vue&type=script&lang=js"
import style0 from "./PeriodoEvaluacionSelect.vue?vue&type=style&index=0&id=3a27528e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a27528e",
  null
  
)

export default component.exports